import {ReactElement} from "react";
import css from "./featureRestrictedOverlay.module.scss";
import {useProperties} from "../../contexts/properties/PropertiesContext";
import cn from "classnames";


export interface IFeatureRestrictedOverlayProps {
    coverPage?: boolean;
}

export default function FeatureRestrictedOverlay({coverPage}: IFeatureRestrictedOverlayProps): ReactElement {
    const {currentProperty} = useProperties();

    return (
        currentProperty?.isAcquisitionProperty ?
            <div className={cn(css.wrapper, coverPage && css.coverPage)}>
                <div className={css.content}>
                    <img src="/acquisition_property_logo_blue.png" className={css.icon} />
                    <div className={css.bodyText}>
                        <h4>Feature Unavailable for Budget Builder Properties</h4>
                        <h5>Click the 'x' in the property selector to exit budget builder mode.</h5>
                    </div>
                </div>
            </div>
        : <></>
    );
}
